import { Fragment } from "react/jsx-runtime";
import { Controller } from "react-hook-form";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ro } from "date-fns/locale";
import { Vocabulary } from "../../Utils/Vocabulary";

type Props = { control: any };

export default function ARRAdmissionDatePicker({ control }: Props) {
  return (
    <Fragment>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ro}>
        <Controller
          name="ARRAdmissionDate"
          control={control}
          render={({ field }) => (
            <DatePicker
              label={Vocabulary.arrAdmissionDate}
              value={field.value ? new Date(field.value) : null}
              onChange={(date) => field.onChange(date?.toISOString() ?? null)}
              slotProps={{ textField: { fullWidth: true, size: "small" } }}
            />
          )}
        />
      </LocalizationProvider>
    </Fragment>
  );
}
